import React, { useState, useEffect } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from './FiltersPartial.js';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import SimpleTableComponent from '../../components/SimpleTableComponent'
import DetailsComponent from '../../components/DetailsComponent'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from 'react-router-dom'
import Page from "../../pages/Page";
import { useParams, useLocation } from 'react-router-dom'
import MonthlyEarningListing from "../earnings/monthly/Listing";
import { toast } from 'react-toastify';
import PageContentWrapper from "../../components/PageContentWrapper";

const Show = (props) => {
  const params = useParams();
  const [ partnerBillingDetail, setPartnerBillingDetails ] = useState(false);
  const [ partnerBillingShowApi ] = getApi('showPartnerBilling')

  function flattenObj(obj, parent, res = {}){
      for(let key in obj){
          let propName = parent ? parent + '_' + key : key;
          if ( obj[key].constructor == Array ){
            res[propName] = obj[key];
          }
          else if(typeof obj[key] == 'object'){
            flattenObj(obj[key], propName, res);
          } else {
            res[propName] = obj[key];
          }
      }
      return res;
  }

  const fetchPartBillingDetails = async () => {
    try {
      const response = await partnerBillingShowApi({ id: params.id }).unwrap();
      setPartnerBillingDetails(flattenObj(response.data.partner_billing));
    } catch (error) {
      toast.error(error.data?.message ||  "Something went wrong")
    }
  }

  useEffect(()=>{
    fetchPartBillingDetails()
  }, [])

  return <PageContentWrapper contentHeading={'Partner Billing Details'}>
      <DetailsComponent data={partnerBillingDetail}/>
      { partnerBillingDetail && <MonthlyEarningListing key={"someRandomKey"} listingParams={{id: partnerBillingDetail.user_id, month: partnerBillingDetail.end_of_month}}/>}
    </PageContentWrapper>

  // <Page
  //     uiPage={PAGES.PartnerBillingsShowPage}
  //     breadcrumbs={[{label: 'Home', url:'/dashboard'}, {label: 'Partner Billings', url:'/partner_billings'}, {label: `Partner Billing:${params.id}`}]}> 
  //     <PageContentWrapper contentHeading={'Partner Billing Details'}>
  //     <DetailsComponent data={partnerBillingDetail}/>
  //     { partnerBillingDetail && <MonthlyEarningListing key={"someRandomKey"} isEditable={partnerBillingDetail.is_editable} listingParams={{id: partnerBillingDetail.user_id, month: partnerBillingDetail.end_of_month}}/>}
  //   </PageContentWrapper>
  // </Page>
}

export default Show;
